import { AxiosError } from "axios";
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import ListaPermissao from "../interfaces/entities/Permissoes/ListaPermissao";
import { Response } from "../interfaces/services/Response";
import { ExcluirPrestador } from "../interfaces/entities/Permissoes/ExcluirPrestador";

export const getPermissoes = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Permissoes/GetPermissoes', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};


export const getPermissaoCadastroBoleto = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/permissoes/getpermissaocadastroboleto', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getPermissaoSegundaViaBoleto = async (): Promise<boolean> => {
  try {
    const response = await apiClientes.get('/permissoes/getpermissao2viaboleto', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return !!response?.data?.isPermissao;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};


export const getPrestadoresConsultados = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Permissoes/GetPrestadoresConsultados',
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getPrestadoresConfianca = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Permissoes/GetPrestadoresConfianca',
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const ativarPrestadorConsultado = async (idPessoa: number, idPermisBenefPrestador: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Permissoes/AtivarPrestadorConsultado', {
      idPessoa,
      idPermisBenefPrestador
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const desativarPrestadorConsultado = async (idPessoa: number, idPermisBenefPrestador: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Permissoes/DesativarPrestadorConsultado', {
      idPessoa,
      idPermisBenefPrestador
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const ativarPrestadorConfianca = async (idPessoa: number, idPermisBenefPrestador: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Permissoes/AtivarPrestadorConfianca', {
      idPessoa,
      idPermisBenefPrestador
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const desativarPrestadorConfianca = async (idPessoa: number, idPermisBenefPrestador: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Permissoes/DesativarPrestadorConfianca', {
      idPessoa,
      idPermisBenefPrestador
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const adicionarPrestadorConfianca = async (idPessoaPrestador: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Permissoes/AdicionarPrestadorConfianca', {
      idPessoaPrestador
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
}

export const atualizarPermissao = async (permissao: ListaPermissao): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Permissoes/AtualizarPermissao', {
      idTipoPermissao: parseInt(permissao.idTipoPermissao),
      idPermissao: parseInt(permissao.idPermissao),
      idPermissaoBenef: parseInt(permissao.idPermissaoBenef),
      valor: !permissao.valor
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const excluirPrestadorConfianca = async (data: ExcluirPrestador): Promise<Response | null> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.post("/Permissoes/ExcluirPrestadorConfianca", {
      idPessoaPrestador: data.idPessoaPrestador.toString(),
      idPermisBenefPrestador: data.idPermisBenefPrestador.toString()
    }, { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};